<template>
  <OverlayLoading :visible="loadingStore.isLoading.length > 0 || !isLoaded" :loadingMessage="loadingStore.loadingMessage"/>
  <v-app v-show="isLoaded">
    <component :is="layoutComponent" />
    <MessageDialog ref="globalMessageDialog" />
  </v-app>
</template>

<script setup lang="ts">
import { ref, nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import { useLoadingStore } from '~/stores/loading';
import OverlayLoading from '~/components/overlay-loading.vue';
import MessageDialog from './components/modal/MessageDialog.vue';
import AdminLayout from './components/admin/admin-layout.vue';
import DefaultLayout from './components/default-layout.vue';
import PropertyManagerLayout from './components/property-manager/property-manager-layout.vue';
import { useProp000Store } from '~/stores/property-manager/prop-000';

const loadingStore = useLoadingStore();

const route = useRoute();

const globalMessageDialog = ref();
const nuxtApp = useNuxtApp();
nuxtApp.provide('messageDialog', globalMessageDialog);

const layoutComponent = computed(() => {
  switch (true) {
  case route.path.includes('/login'):
    return DefaultLayout ;
  case route.path.startsWith('/admin'):
    return AdminLayout;

  case route.path.startsWith('/property-manager'):
    return PropertyManagerLayout;
  
  default:
    return DefaultLayout ;
}
});

const isLoaded = ref(false);

onMounted(async () => {
  const prop000Store = useProp000Store();
  prop000Store.fetchPropertyId();
  await nextTick();
  isLoaded.value = true;
});
</script>
<style>
.min-height {
  min-height: 94vh;
}
html {
  overflow: hidden;
}
</style>
